import Stepper from 'components/ReactStepper';
import StyledStepperWrapper from './styles';

export default function KizenInlineStepper({
  size = 31,
  activeColor = 'var(--color-button-secondary-default)',
  completeColor = 'var(--color-button-secondary-default)',
  defaultColor = 'var(--color-background-medium)',
  activeTitleColor = 'var(--color-button-secondary-default)',
  completeTitleColor = 'var(--color-button-secondary-default)',
  defaultTitleColor = 'var(--color-font-placeholder)',
  circleFontSize = 10,
  titleFontSize = 14,
  titleTop = 8,
  completeBarColor = 'var(--color-button-secondary-default)',
  defaultBarColor = 'var(--color-background-medium)',
  lineMarginOffset = 0,
  steps,
  ...rest
}) {
  return (
    <StyledStepperWrapper>
      <Stepper
        size={size}
        activeColor={activeColor}
        completeColor={completeColor}
        defaultColor={defaultColor}
        activeTitleColor={activeTitleColor}
        completeTitleColor={completeTitleColor}
        defaultTitleColor={defaultTitleColor}
        circleFontSize={circleFontSize}
        titleFontSize={titleFontSize}
        titleTop={titleTop}
        completeBarColor={completeBarColor}
        defaultBarColor={defaultBarColor}
        lineMarginOffset={lineMarginOffset}
        steps={steps}
        {...rest}
      />
    </StyledStepperWrapper>
  );
}
